import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { JwtDecoder } from './auth/jwt-decoder.service';
import { ApiEndpoints } from './api-endpoints.service';
import { StorageService } from './auth/storage.service';

@Injectable({
  providedIn: 'root',
})
export class AgentProfileService {
  private agentData = new Subject<any>();
  private agentSubscriptionData = new Subject<any>();
  public agentFetched = this.agentData.asObservable();
  public agentSubsciptionFetched = this.agentSubscriptionData.asObservable();
  public readyAgent: any;
  public readyAgentSubscription: any;
  public readyAgentAgency: any;
  public agentEvents = new Subject<any>();
  public readyAgentEvents: any;
  private agentAgetncyData = new Subject<any>();
  public agentAgencyFetched = this.agentAgetncyData.asObservable();
  public readyAgentPermissions: any;
  public agentPermissionsData = new Subject<any>();
  public agentPermissionsFetched = this.agentPermissionsData.asObservable();

  constructor(
    private jwtDecoder: JwtDecoder,
    private apiEndpoint: ApiEndpoints,
    private storageService: StorageService,
  ) {}

  addAgentData(agent) {
    this.readyAgent = agent;
    this.agentData.next(agent);
  }

  addAgentSubscription(data) {
    this.readyAgentSubscription = data;
    this.agentSubscriptionData.next(data);
  }

  addAgentAgencyData(data) {
    this.readyAgentAgency = data;
    this.agentAgetncyData.next(data);
  }

  addAgentPermissions(data) {
    this.readyAgentPermissions = data;
    this.agentPermissionsData.next(data);
  }
  /**
   * Get the agent profile meta
   */
  getAgent() {
    let userId;
    if (this.jwtDecoder.getUserInformation()) {
      userId = this.jwtDecoder.getUserInformation().user.id;
    }
    return this.apiEndpoint.get('getProfileMeta', userId);
  }

  /**
   * Get the agent profile meta
   */
  getAgentPermissions() {
    let userId;
    if (this.jwtDecoder.getUserInformation()) {
      userId = this.jwtDecoder.getUserInformation().user.id;
    }
    return this.apiEndpoint.get('getProfilePermissions', userId);
  }

  getAgentSubscription() {
    let userId;
    if (this.jwtDecoder.getUserInformation()) {
      userId = this.jwtDecoder.getUserInformation().user.id;
    }
    return this.apiEndpoint.get('getProfileSubscription', userId);
  }

  /**
   * sign out agent from the dashboard
   *
   * deletes the cookie that indicates being signed in
   */
  signOut() {
    this.storageService.deleteCookie('squanchy');
  }
  /**
   * @description
   * Fetch the agent data
   */
  getAgentSubject() {
    if (this.agentData) {
      return this.agentData;
    }
  }

  /**
   * @description get all agents in the same agency as the current agent
   */
  getAgencyAgents() {
    return this.apiEndpoint.get('agencyAgent', {});
  }

  getAgentAgency() {
    return this.apiEndpoint.get('getAgentAgency', {});
  }

  /**
   * Get the agent profile meta
   */
  getAgentSettings(template) {
    return this.apiEndpoint.get('getAgentSettings', template);
  }

  /**
   * Get Agent events
   */
  getAgentEvents() {
    let userId;
    if (this.jwtDecoder.getUserInformation()) {
      userId = this.jwtDecoder.getUserInformation().user.id;
    }
    return this.apiEndpoint.get('agentEvents', userId);
  }

  updateAgentEvents(data) {
    this.readyAgentEvents = data;
    this.agentEvents.next(data);
  }

  addAgentEvents(data) {
    return this.apiEndpoint.post('addAgentEvents', data);
  }

  deleteAgentEvent(postBody) {
    return this.apiEndpoint.post('deleteAgentEvent', postBody);
  }

  fethcLicenceCount() {
    return this.apiEndpoint.get('fetchLicenceCount', {});
  }
}
